export const ls_save = (key, value) => {
    if (value === null) {
        localStorage.removeItem(key);
        return;
    }

    localStorage.setItem(key, JSON.stringify(value));
};

export const ls_read = (key) => {
    try {
        return JSON.parse(localStorage.getItem(key));
    } catch (e) {
        return null;
    }
};

export function getLocalStorageCurrentIdentity() {
    try {
        return JSON.parse(sessionStorage.getItem('_currentIdentity')) ?? ls_read('_currentIdentity');
    } catch (e) {
        return ls_read('_currentIdentity');
    }
}

export function setLocalStorageCurrentIdentity(identityOrNull, remember = true) {
    if (identityOrNull === null) {
        localStorage.removeItem('_currentIdentity');
        sessionStorage.removeItem('_currentIdentity');
        return;
    }

    if (remember) {
        sessionStorage.removeItem('_currentIdentity');
        ls_save('_currentIdentity', identityOrNull);
        return;
    }

    localStorage.removeItem('_currentIdentity');
    sessionStorage.setItem('_currentIdentity', JSON.stringify(identityOrNull));
}

export function getLocalStorageCurrentProjectId() {
    return ls_read('_currentProjectId');
}

export function setLocalStorageCurrentProjectId(projectIdOrNull) {
    ls_save('_currentProjectId', projectIdOrNull);
}

export function getLocalStorageCurrentProjectName() {
    return ls_read('_currentProjectName');
}

export function setLocalStorageCurrentProjectName(projectNameOrNull) {
    ls_save('_currentProjectName', projectNameOrNull);
}

export function getLocalStorageUpgatesPendingToken() {
    return ls_read('_upgatesPendingToken');
}

export function setLocalStorageUpgatesPendingToken(tokenOrNull) {
    ls_save('_upgatesPendingToken', tokenOrNull);
}

export function getLocalStoragePendingAddon() {
    const raw = ls_read('_pendingAddon');

    if (!raw) {
        const legacyUpgatesToken = getLocalStorageUpgatesPendingToken();
        return legacyUpgatesToken ? {type: 'upgates', token: legacyUpgatesToken} : null;
    }

    return raw?.type && raw?.token ? raw : null;
}

export function setLocalStoragePendingAddon(addonOrNull) {
    ls_save('_pendingAddon', addonOrNull);
}
